import { QueryClient } from '@tanstack/react-query';

export enum QueryKey {
  Transactions = 'Transactions',
}

export const queryClient = new QueryClient()
